
function ComputerMoveExpert(squares) {
/*
   This code came from this article: https://www.freecodecamp.org/news/how-to-make-your-tic-tac-toe-game-unbeatable-by-using-the-minimax-algorithm-9d690bad4b37/
   We receive as input a copy of the current game board. It is the computer's turn and this algorithm will determing the best computer move
   by looking ahead at all the possible computer and human moves and calculating the best outcome for the computer. 
   In theory it should never lose. In order to determine the first computer move it looks at over 59,700 scenarios, it plays the entire game 27,732 times.
*/

  const huPlayer = "X"; // human player
  const aiPlayer = "O"; // computer player
  const callingParent = "main";
  let iter = 0;
  let board = [0, 1, 2, 3, 4, 5, 6, 7, 8];

  // convert our game board to their format
  for (let i = 0; i < squares.length; i++) {
    if(squares[i] === 'X' || squares[i] === 'O')
      board[i] = squares[i];
  }

  return minimax(board, aiPlayer, callingParent);
  
  // the main minmax function
  function minimax(reboard, player, parent) {
    iter++;
    let emptySquaresArray = avail(reboard); // array of all empty spots on the board  

    // Here we check for the terminal states that will end the loop and return an appropriate value
    if (winning(reboard, huPlayer)) { // if human wins we return -10
      return {
        score: -10
      };
    } else if (winning(reboard, aiPlayer)) { // if computer wins we return +10  
      return {
        score: 10
      };
    } else if (emptySquaresArray.length === 0) { // this means there are no more empty spots, it is a tie
      return {
        score: 0
      };
    }
  
    let moves = []; // array to collect all the objects

    // loop through all empty squares on the board
    for (let i = 0; i < emptySquaresArray.length; i++) {

    // create an object for each and store the index of that spot
      let move = {};
      move.index = reboard[emptySquaresArray[i]];

      // set the empty spot to the current player
      reboard[emptySquaresArray[i]] = player;
  
      // collect the score that resulted from calling minmax on the opponent of the current player
      if (player === aiPlayer) {
        let g = minimax(reboard, huPlayer, parent="inside-hu"); // recursive call, switching players
        move.score = g.score;  // this is the score for this entire scenario
      } else {
        let g = minimax(reboard, aiPlayer, parent="inside-ai"); // recursive call, switching players
        move.score = g.score;  // this is the score for this entire scenario
      }
      // reset the spot to empty
      reboard[emptySquaresArray[i]] = move.index;
      // push the object to the array
      moves.push(move);
    }
    
    let bestMove;
    let bestScore;
    
    if (player === aiPlayer) { // if it is the computer's turn loop over the moves and choose move with highest score
      bestScore = -10000;
      for (let i = 0; i < moves.length; i++) {
        if (moves[i].score > bestScore) {
          bestScore = moves[i].score;
          bestMove = i;
        }
      }
    } else { // it is the human's turn so choose the move with the lowest score
      bestScore = 10000;
      for (let i = 0; i < moves.length; i++) {
        if (moves[i].score < bestScore) {
          bestScore = moves[i].score;
          bestMove = i;
        }
      }
    }
 
    return moves[bestMove]; // return the chosen move from the moves array
  }
  
  //returns a list of the indexes of available spots on the board
  function avail(reboard) {
    let emptyArray = reboard.filter(s => s !== "X" && s !== "O" && s !== null);
    return emptyArray;
  }
  
  // check winning combinations for a player using the board indexes
  function winning(board, player) {
    if (
      (board[0] === player && board[1] === player && board[2] === player) ||
      (board[3] === player && board[4] === player && board[5] === player) ||
      (board[6] === player && board[7] === player && board[8] === player) ||
      (board[0] === player && board[3] === player && board[6] === player) ||
      (board[1] === player && board[4] === player && board[7] === player) ||
      (board[2] === player && board[5] === player && board[8] === player) ||
      (board[0] === player && board[4] === player && board[8] === player) ||
      (board[2] === player && board[4] === player && board[6] === player)
    ) {
      return true;
    } else {
      return false;
    }
  }
}

export default ComputerMoveExpert;